import React, {FC, useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {Navbar as GlobalNavbar, NavbarItem} from "../../../../Components/Layout/Navbar";
import Header from "../../../../Components/Layout/Header";
import GlobalLoader from "Vendor/Components/GlobalLoader";
import useTranslationData from "Vendor/Utils/TranslationDataUtils";
import Api from "Vendor/Api";
import Catalog from "../../../../Entity/Catalog";

const Navbar: FC = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()
    const {translate} = useTranslationData()
    const [catalog, setCatalog] = useState<Catalog|undefined>(undefined)
    const [show, setShow] = useState<boolean>(false)
    const [search, setSearch] = useState<string>('')
    const [handleAdd, setHandleAdd] = useState<(() => void)|undefined>(undefined)
    const [items, setItems] = useState<NavbarItem[]>([])
    const [showAddButton, setShowAddButton] = useState<boolean>(true)
    const [showSearch, setShowSearch] = useState<boolean>(true)

    useEffect(() => {
        if (location && location.state && typeof location.state === 'object') {
            let catalog = location.state as Catalog
            setCatalog(catalog);
        }
        else {
            let id = params.id;
            Api.get('/admin/edition/catalog/' + id)
                .then((response ) => {
                    let catalog = response.data as Catalog
                    setCatalog(catalog)
                })
        }
    }, [location, params])

    useEffect(() => {
        let tempItems: NavbarItem[] = []
        if (catalog) {
            tempItems.push({
                i18nLabel: 'app.main',
                path: ''
            })
            tempItems.push({
                i18nLabel: 'app.product_card',
                path: 'card'
            })
            tempItems.push({
                i18nLabel: 'app.listing',
                path: 'listing'
            })
            tempItems.push({
                i18nLabel: 'app.export_config',
                path: 'export-config'
            })
            tempItems.push({
                i18nLabel: 'app.product_groups',
                path: 'group'
            })
        }
        setItems(tempItems)
    }, [catalog])

    return (
        <>
            {!catalog
                ? <GlobalLoader />
                : <>
                    <Header title={catalog ? translate(catalog, 'name') : ''} prev={() => {
                        navigate('/admin/edition/catalog')
                    }} search={showSearch ? search : undefined}
                            setSearch={showSearch ? setSearch : undefined}
                            add={showAddButton ? () => {
                                setShow(true)
                            } : undefined} />
                    <GlobalNavbar locationBase={"/admin/edition/catalog/" + (catalog?.id ?? '')} state={catalog} items={items} />
                    {location.pathname.endsWith('/export-config')
                        ? <Outlet context={[show, setShow, search, setSearch, setShowAddButton, setShowSearch, catalog.id]} />
                        : <Outlet context={[catalog, setCatalog, show, setShow, search, setSearch, setHandleAdd]} />
                    }
                </>
            }
        </>
    )
}

export default Navbar
